import RiskRangeChart from "./RiskRangeChart.jsx";

export default RiskRangeChart;



// WEBPACK FOOTER //
// ./src/components/common/riskRangeChart/index.js